import { AppConstants } from '../../constants/AppConstants';
import { Col, Modal, Row } from 'react-bootstrap';
import classes from './MicrositeReviewComponent.module.css';
import { useState } from 'react';
import { ReviewCardsComponent } from '../cards/reviewCardsComponent/ReviewCardsComponent';
import { ReviewCards } from '../cards/reviewCardsComponent/ReviewCards';

export const MicrositeReviewComponent = (props) => {
  const [cardCount, setCardCount] = useState(
    AppConstants.cardCounts.micrositeReviewCardCount
  );
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);

  return (
    <div className={classes.micrositeReviewSection}>
      <p className={`${classes.aboutExpertHeading} mb-3`}>
        Reviews from Learners
      </p>
      {props.micrositeReviews.slice(0, cardCount).map((review, index) => {
        return (
          <div>
            <ReviewCards review={review} />
            {index + 1 < cardCount &&
              index + 1 < props.micrositeReviews.length && (
                <hr className={classes.horizontalBreak} />
              )}
          </div>
        );
      })}

      {cardCount < props.micrositeReviews.length && (
        <Row xs={1} sm={1} md={1} lg={1} xl={1} className={classes.loadMore}>
          <Col>
            {cardCount < props.micrositeReviews.length && (
              <button
                className="loadMoreButton"
                onClick={() => setShowModal(true)}
              >
                {AppConstants.moreReviewsText}
              </button>
            )}
          </Col>
        </Row>
      )}
      <Modal
        show={showModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        className={classes.modalContent}
      >
        <Modal.Header closeButton>
          <Modal.Title className={classes.modalTitle}>
            Reviews from Learners
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className={classes.modalBody}>
          {props.micrositeReviews.map((review, index) => (
            <div key={index}>
              <ReviewCardsComponent review={review} />
              {index + 1 < props.micrositeReviews.length && (
                <hr className={classes.horizontalBreak} />
              )}
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </div>
  );
};
